<template>
<!-- ====================== 페이지내 내용 ======================  -->
    <div>
        <div class="py-3"></div>
        <v-card
            class="mx-auto"
            max-width="90%"
        >
        <v-toolbar
            color='light-blue darken-3'
            dark
        >
            <v-toolbar-title>프로젝트 리스트</v-toolbar-title>
            <v-spacer/>
            <v-btn
                class="ml-3"
                color='indigo darken-3'
                @click="clilckCreateProject"
                width="150px">
                <v-icon>mdi-plus</v-icon>
                프로젝트 등록
            </v-btn>
        </v-toolbar>
        <!-- ====================== 이쪽에 데이터테이블이 들어간다 ====================== -->
            <v-data-table
                v-model="selected1"
                :headers="headers"
                :items="dtatatabledata1"
                :search="projectSearch"
                item-key="idx"
                class="elevation-1"
                :loading="dtatatabledata1[0]?false:true"
                loading-text="데이터를 가져오는 중입니다. 잠시만 기다려 주세요."
                show-select
                :single-select="true"
            >
                <template v-slot:item.actions="{ item }">
                    <v-btn
                        small
                        dark
                        color='green'
                        @click="showLog(item)">
                        로그
                    </v-btn>
                </template>
                <template v-slot:item.actionsT="{ item }">
                    <v-btn
                        small
                        dark
                        color='red'
                        @click="updateProjectDiolog(item)">
                        수정
                    </v-btn>
                </template>
                <template v-slot:item.project_group="{ item }">
                    {{"매드몹"}}
                </template>
                <template v-slot:top>
                    <v-spacer/>
                    <v-text-field
                        v-model="projectSearch"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        class="mr-4 ml-4 mb-3"
                    ></v-text-field>
                    <v-spacer/>
                </template>
            </v-data-table>
        </v-card>
            <div class="py-3"></div>
        <v-card
            class="mx-auto"
            max-width="90%"
        >
        <v-toolbar
            color='#37474F'
            dark
        >
            <v-toolbar-title> {{  dtatatabledata2[0]?`[ ${productDatatableName} ]  상품리스트`:'상품리스트'}}</v-toolbar-title>
            <v-spacer/>
            <v-btn
                class="ml-3"
                color='indigo darken-3'
                @click="clilckCreateProduct"
                :disabled="this.selected1[0]?false:true"
                width="150px">
                <v-icon>mdi-plus</v-icon>
                상품 등록
            </v-btn>
        </v-toolbar>
        <!-- ====================== 이쪽에 데이터테이블이 들어간다 ====================== -->
            <v-data-table
                :headers="headers2"
                :items="dtatatabledata2"
                item-key="seq_no"
                class="elevation-1"
                no-data-text="프로젝트를 선택해 주세요."
                hide-default-footer
                :items-per-page="-1"
            >
                <template v-slot:item.actions="{ item }">
                    <v-btn
                        small
                        dark
                        color='red'
                        @click="updateProductDiolog(item)">
                        수정
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>
    <v-dialog
      v-model="dialog1"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5">
            {{ dialog1Title }}
        </v-card-title>

        <v-card-text>
            <v-text-field
            v-model="projectDialogData.idx"
            label="인덱스"
            required
            outlined
            dense
            disabled
            ></v-text-field>
            <v-select
                v-model="projectDialogData.project_group"
                :items="projectGroupItems"
                label="프로젝트그룹"
                item-text="project_group"
                item-value="project_group_flag"
                required
                outlined
                dense
            ></v-select>
            <v-text-field
            v-model="projectDialogData.project_name"
            label="프로젝트명"
            required
            outlined
            dense
            ></v-text-field>
            <v-text-field
            v-model="projectDialogData.package_name"
            label="패키지명(번들ID)"
            required
            outlined
            dense
            ></v-text-field>
            <v-text-field
            v-model="projectDialogData.callback_url"
            label="CallBackURL"
            required
            outlined
            dense
            ></v-text-field>
            <v-select
                v-model="projectDialogData.kakao_flag"
                :items="kakaoFlagItems"
                label="카카오프로젝트"
                item-text="text"
                item-value="kakao_flag"
                required
                outlined
                dense
            ></v-select>
            <v-select
                v-model="projectDialogData.android_open_flag"
                :items="androidOpenFlagItems"
                label="안드로이드"
                item-text="text"
                item-value="android_open_flag"
                required
                outlined
                dense
            ></v-select>
            <v-select
                v-model="projectDialogData.ios_open_flag"
                :items="iosOpenFlagItems"
                label="ios"
                item-text="text"
                item-value="ios_open_flag"
                required
                outlined
                dense
            ></v-select>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog1 = false"
          >
            취소
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="dialog1Title.slice(-2) == '등록'?submitCreateProject():submitUpdateProject()"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog2"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5">
            {{ dialog2Title }}
        </v-card-title>

        <v-card-text>
            <v-text-field
            v-model="prodectDialogData.seq_no"
            label="seqNo"
            required
            outlined
            dense
            disabled
            ></v-text-field>
            <v-text-field
            v-model="prodectDialogData.project_idx"
            label="IDX"
            required
            outlined
            dense
            disabled
            ></v-text-field>
            <v-text-field
            v-model="prodectDialogData.product_name"
            label="상품명"
            required
            outlined
            dense
            ></v-text-field>
            <v-text-field
            v-model="prodectDialogData.product_id_android"
            label="상품ID(Android)"
            required
            outlined
            dense
            ></v-text-field>
            <v-text-field
            v-model="prodectDialogData.product_id_ios"
            label="상품ID(IOS)"
            required
            outlined
            dense
            ></v-text-field>
            <v-text-field
            v-model="prodectDialogData.product_id_onestore"
            label="상품ID(OneStore)"
            required
            outlined
            dense
            ></v-text-field>
            <v-checkbox
            class="mt-0 mb-2"
            v-model="prodectDialogData.product_type"
            label="Non-Consumable"
            :false-value="0"
            :true-value="1"
            dense
            ></v-checkbox>
            <v-text-field
            v-model="prodectDialogData.product_cost"
            label="상품가격"
            required
            outlined
            dense
            ></v-text-field>
            <v-text-field
            v-model="prodectDialogData.product_give_cash"
            label="지급캐시"
            required
            outlined
            dense
            ></v-text-field>
            <v-text-field
            v-model="prodectDialogData.product_bonus"
            label="보너스캐시"
            required
            outlined
            dense
            ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog2 = false"
          >
            취소
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="dialog2Title.slice(-2) == '등록'?submitCreateProduct():submitUpdateProduct()"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog3"
    >
      <v-card>
        <v-card-title class="text-h5">
            <span class="ml-4">
                {{ `[ ${logDialogTitle} ] 구매이력`}}
            </span>
            <v-spacer>
            </v-spacer>
            <span class="mr-6">
                {{ `누적금액 ₩${cumulativePurchasesAmount}`}}
            </span>
            <span class="mr-4">
                {{ `누적건수 ${cumulativePurchases}건`}}
            </span>

        </v-card-title>

        <v-card-text>
            <v-data-table
                :headers="headers3"
                :items="dtatatabledata3"
                item-key="seq_no"
                :search="logSearch"
                class="elevation-0"
                no-data-text="데이터를 가져오는 중입니다."
            >
                <template v-slot:item.actions="{ item }">
                <v-btn
                    small
                    dark
                    color='red'
                    @click="clickLogDeleteBtn(item)"
                >
                    <v-icon small >mdi-delete</v-icon>
                    삭제
                </v-btn>
                </template>
                <template v-slot:top>
                    <v-spacer/>
                    <v-text-field
                        v-model="logSearch"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        class="mr-4 ml-4 mb-3"
                    ></v-text-field>
                    <v-spacer/>
                </template>
            </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog3 = false"
          >
            닫기
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <v-snackbar
        v-model="snackbar"
        :vertical="true"
        >
        {{ text }}
        </v-snackbar>
        <div class="py-3"></div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',

    data: () => ({
        projectGroupItems: [
            // {'project_group':'21g', 'project_group_flag':1},
            // {'project_group':'7day', 'project_group_flag':2},
            // {'project_group':'0Back', 'project_group_flag':3},
            // {'project_group':'NewDay7', 'project_group_flag':4},
            // {'project_group':'1Sec', 'project_group_flag':5},
            // {'project_group':'Bbulle', 'project_group_flag':6},
            {'project_group':'매드몹', 'project_group_flag':7},
        ],
        kakaoFlagItems: [
            {'text':'카카오연동X', 'kakao_flag':0},
            {'text':'카카오연동O', 'kakao_flag':1},
        ],
        androidOpenFlagItems: [
            {'text':'테스트중', 'android_open_flag':0},
            {'text':'서비스중', 'android_open_flag':1},
        ],
        iosOpenFlagItems: [
            {'text':'테스트중', 'ios_open_flag':0},
            {'text':'서비스중', 'ios_open_flag':1},
        ],
        // 프로젝트 다이어로그 변수
        projectDialogData:{
            idx:'',
            project_group:'',
            project_name:'',
            package_name:'',
            callback_url:'',
            kakao_flag:'',
            android_open_flag:'',
            ios_open_flag:'',
        },
        // 상품 다이어로그 변수
        prodectDialogData:{
            seq_no:'',
            project_idx:'',
            product_name:'',
            product_id_android:'',
            product_id_ios:'',
            product_id_onestore:'',
            product_type:'',
            product_cost:'',
            product_give_cash:'',
            product_bonus:''
        },
        productDatatableName:'',
        logDialogTitle:'',
        cumulativePurchases:'',
        cumulativePurchasesAmount:'',
        logSearch:'',
        projectSearch:'',
        dtatatabledata1:[],
        dtatatabledata2:[],
        dtatatabledata3:[],
        selected1:'',
        selected2:'',
        snackbar:false,
        text:'',
        dialog1:false,
        dialog1Title:'',
        dialog2:false,
        dialog2Title:'',
        dialog3:false,
        search:'',
        today: moment().format('YYYY-MM-DD'),
        subDate:'',
        tempInfo:[moment().format('YYYY-MM-DD')],
        app_ad:'front',
        days:1,
        menu: false,
        menu2:false,
        date:"",
        date2:""
    }),

    created()
    {
        this.getProjectData()
    },

    methods:{
        ...mapActions([
            'GET_BILLING_PROJECTS',
            'GET_BILLING_PRODUCTS',
            'GET_BILLING_LOG',
            'UPDATE_BILLING_PROJECT',
            'CREATE_BILLING_PROJECT',
            'UPDATE_BILLING_PRODUCT',
            'CREATE_BILLING_PRODUCT',
            'DELETE_BILLING_LOG'
        ]),
        refreash(){
            // 모든 데이터들을 새로 가져온다.

            // select 초기화
            this.selected1 = []
            //프로젝트 새로 가져오기
            this.getProjectData()

        },
        async clickLogDeleteBtn(item){
            // 삭제 버튼을 누르면 실행된다.

            const seq_no = item.seq_no

            const deleteResult = await this.DELETE_BILLING_LOG({ seq_no })

            this.dialog3 = false

            this.text = deleteResult.message
            this.snackbar = true

            this.refreash()

            console.log(deleteResult)
        },
        async submitCreateProject(){
            // 프로젝트 생성 서브밋

            // 각 변수들을 대입시켜준다.
            const project_group = this.projectDialogData.project_group
            const project_name = this.projectDialogData.project_name
            const package_name = this.projectDialogData.package_name
            const callback_url = this.projectDialogData.callback_url
            const kakao_flag = this.projectDialogData.kakao_flag
            const android_open_flag = this.projectDialogData.android_open_flag
            const ios_open_flag = this.projectDialogData.ios_open_flag

            // 메서드를 실행시킨다.
            const createResult = await this.CREATE_BILLING_PROJECT({
            project_group,
            project_name,
            package_name,
            callback_url,
            kakao_flag,
            android_open_flag,
            ios_open_flag,
            })

            this.dialog1 = false

            this.text = createResult.message
            this.snackbar = true

            this.refreash()

            console.log(createResult)
        },
        async submitUpdateProject(){
            // 프로젝트 업데이트 서브밋됨

            // 각 변수들을 대입시켜준다.
            const idx = this.projectDialogData.idx
            const project_group = this.projectDialogData.project_group
            const project_name = this.projectDialogData.project_name
            const package_name = this.projectDialogData.package_name
            const callback_url = this.projectDialogData.callback_url
            const kakao_flag = this.projectDialogData.kakao_flag
            const android_open_flag = this.projectDialogData.android_open_flag
            const ios_open_flag = this.projectDialogData.ios_open_flag

            // 메서드를 실행시킨다.
            const updateResult = await this.UPDATE_BILLING_PROJECT({
            idx,
            project_group,
            project_name,
            package_name,
            callback_url,
            kakao_flag,
            android_open_flag,
            ios_open_flag,
            })

            this.dialog1 = false

            this.text = updateResult.message
            this.snackbar = true

            this.refreash()

            console.log(updateResult)
        },
        async submitCreateProduct(){
            // 프로덕트 생성 서브밋됨

            // 각 변수들을 대입시켜준다.
            const project_idx = this.prodectDialogData.project_idx
            const product_name = this.prodectDialogData.product_name
            const product_id_android = this.prodectDialogData.product_id_android
            const product_id_ios = this.prodectDialogData.product_id_ios
            const product_id_onestore = this.prodectDialogData.product_id_onestore
            const product_type = this.prodectDialogData.product_type
            const product_cost = this.prodectDialogData.product_cost
            const product_give_cash = this.prodectDialogData.product_give_cash
            const product_bonus = this.prodectDialogData.product_bonus

            // 메서드를 실행시킨다.
            const createResult = await this.CREATE_BILLING_PRODUCT({
            project_idx,
            product_name,
            product_id_android,
            product_id_ios,
            product_id_onestore,
            product_type,
            product_cost,
            product_give_cash,
            product_bonus,
            })

            this.dialog2 = false

            this.text = createResult.message
            this.snackbar = true

            this.refreash()

            console.log(createResult)
        },
        async submitUpdateProduct(){
            // 프로덕트 업데이트 서브밋됨

            // 각 변수들을 대입시켜준다.
            const seq_no = this.prodectDialogData.seq_no
            const project_idx = this.prodectDialogData.project_idx
            const product_name = this.prodectDialogData.product_name
            const product_id_android = this.prodectDialogData.product_id_android
            const product_id_ios = this.prodectDialogData.product_id_ios
            const product_id_onestore = this.prodectDialogData.product_id_onestore
            const product_type = this.prodectDialogData.product_type
            const product_cost = this.prodectDialogData.product_cost
            const product_give_cash = this.prodectDialogData.product_give_cash
            const product_bonus = this.prodectDialogData.product_bonus

            // 메서드를 실행시킨다.
            const updateResult = await this.UPDATE_BILLING_PRODUCT({
            seq_no,
            project_idx,
            product_name,
            product_id_android,
            product_id_ios,
            product_id_onestore,
            product_type,
            product_cost,
            product_give_cash,
            product_bonus,
            })

            this.dialog2 = false

            this.text = updateResult.message
            this.snackbar = true

            this.refreash()

            console.log(updateResult)
        },

        clilckCreateProject(){
            // 프로젝트 등록 다이어로그를 연다.
            this.projectDialogData.idx = ''
            this.projectDialogData.project_group = ''
            this.projectDialogData.project_name = ''
            this.projectDialogData.package_name = ''
            this.projectDialogData.callback_url = ''
            this.projectDialogData.kakao_flag = ''
            this.projectDialogData.android_open_flag = ''
            this.projectDialogData.ios_open_flag = ''

            this.dialog1Title = `프로젝트등록`

            this.dialog1 = true
        },
        clilckCreateProduct(){
            // 상품 등록 다이어로그를 연다
            this.prodectDialogData.seq_no = ''
            this.prodectDialogData.project_idx = this.selected1[0].idx
            this.prodectDialogData.product_name = ''
            this.prodectDialogData.product_id_android = ''
            this.prodectDialogData.product_id_ios = ''
            this.prodectDialogData.product_id_onestore = ''
            this.prodectDialogData.product_type = ''
            this.prodectDialogData.product_cost = ''
            this.prodectDialogData.product_give_cash = ''
            this.prodectDialogData.product_bonus = ''

            this.dialog2Title = `[ ${this.selected1[0].project_name} ] 상품등록`

            this.dialog2 = true
        },
        showLog(item){
            // 매개변수로 받은 패키지를 사용하여 해당 프로젝트의 구입 로그를 요청하고 받아 로그 데이터테이블에 넣어준다 그 후 로그 다이어로그를 연다.
            console.log('구매 이력을 보여주는 프로젝트의 패키지',item.package_name)
            this.getBillingLog(item.package_name)
            // 누적구매건수와 누적구매액을 산출하는 로직 필요
            this.logSearch = ''
            this.logDialogTitle = item.project_name
            this.dialog3 = true
        },
        updateProjectDiolog(item){
            // 프로젝트를 수정한다
            // 프로젝트 다이어로그를 연 다음에 item의 값을 넣어준다
            // 다이어로그의 이름을 만들어준다.

            this.projectDialogData.idx = item.idx
            this.projectDialogData.project_group = item.project_group
            this.projectDialogData.project_name = item.project_name
            this.projectDialogData.package_name = item.package_name
            this.projectDialogData.callback_url = item.callback_url
            this.projectDialogData.kakao_flag = item.kakao_flag
            this.projectDialogData.android_open_flag = item.android_open_flag
            this.projectDialogData.ios_open_flag = item.ios_open_flag

            this.dialog1Title = `[ ${item.project_name} ] 프로젝트수정`

            this.dialog1 = true
        },
        updateProductDiolog(item){
            // 상품을 수정한다.
            // 프로덕트 다이어로그를 연 다음에 item의 값을 넣어준다.
            // 다이어로그의 이름을 만들엉준다.

            this.prodectDialogData.seq_no = item.seq_no
            this.prodectDialogData.project_idx = item.project_idx
            this.prodectDialogData.product_name = item.product_name
            this.prodectDialogData.product_id_android = item.product_id_android
            this.prodectDialogData.product_id_ios = item.product_id_ios
            this.prodectDialogData.product_id_onestore = item.product_id_onestore
            this.prodectDialogData.product_type = item.product_type
            this.prodectDialogData.product_cost = item.product_cost
            this.prodectDialogData.product_give_cash = item.product_give_cash
            this.prodectDialogData.product_bonus = item.product_bonus

            this.dialog2Title = `[ ${this.selected1[0].project_name} > ${item.product_name} ] 상품수정`

            this.dialog2 = true
        },
        deleteLog(seqNo){
            // 매개변수로 받은 seqNo 사용하여 해당 구매이력을 삭제하는 요청을 보낸다. 그 후 결과를 받아온다.
        },
        async getProjectData(){
            console.log('통계 데이터 가져오기 함수 실행됨')
            // 변수가 없다.
            this.dtatatabledata1 = Object.values(await this.GET_BILLING_PROJECTS())
            console.log('받아온 데이터 1 : ',this.dtatatabledata1)
        },
        async getProductData(IDX){
            const idx = IDX
            this.dtatatabledata2 = Object.values(await this.GET_BILLING_PRODUCTS({idx}))
            console.log('받아온 데이터 2 : ',this.dtatatabledata1)
        },
        async getBillingLog(package_name){
            this.dtatatabledata3 = Object.values(await this.GET_BILLING_LOG({package_name}))
            this.cumulativePurchases = this.dtatatabledata3.length.toLocaleString()
            this.cumulativePurchasesAmount = this.dtatatabledata3.reduce((p, c, i, a) => {
                return p + c.product_cost
            }, 0).toLocaleString()
            console.log('받아온 데이터 3 : ',this.dtatatabledata3)
        },
    },
    computed: {
        headers () {
            return [            
            { text: 'IDX', value: 'idx', sortable: true },
            { text: `프로젝트그룹`, value: 'project_group', sortable: true },
            { text: `프로젝트명`, value: 'project_name', sortable: false },
            { text: `패키지명(번들ID)`, value: 'package_name', sortable: false },
            { text: 'CallBackURL', value: 'callback_url', sortable: false  },
            { text: '수정', value: 'actionsT', sortable: false, width:50},
            { text: '로그', value: 'actions', sortable: false ,width:50},
        ]
        },
        headers2 () {
            return [            
            { text: 'seqNo', value: 'seq_no', sortable: true },
            { text: `IDX`, value: 'project_idx', sortable: false },
            { text: `상품명`, value: 'product_name', sortable: false },
            { text: `상품ID(Android)`, value: 'product_id_android', sortable: false},
            { text: '상품ID(IOS)', value: 'product_id_ios', sortable: false },
            { text: '상품ID(OneStore)', value: 'product_id_onestore', sortable: false },
            { text: '상품 가격', value: 'product_cost', sortable: false },
            { text: '지급 캐시', value: 'product_give_cash', sortable: false },
            { text: '보너스 캐시', value: 'product_bonus', sortable: false },
            { text: '수정', value: 'actions', sortable: false ,width:50},
        ]
        },
        headers3 () {
            return [            
            { text: 'seqNo', value: 'seq_no', sortable: true },
            { text: `결재OS`, value: 'os_flag', sortable: false },
            { text: `구매요청번호`, value: 'order_id', sortable: false },
            { text: `패키지명(번들ID)`, value: 'package_name', sortable: false},
            { text: '유저ID', value: 'user_id', sortable: false },
            { text: '상품코드', value: 'product_id', sortable: false },
            { text: '상품가격', value: 'product_cost', sortable: false },
            { text: '과금일자', value: 'reg_date', sortable: false },
            { text: '삭제', value: 'actions' },
        ]
        },
    },
    components:{
    },
    watch :{
        selected1: function() {
            // 만약에 selected1가 빈 배열이라면, select2와 dtatatabledata2를 비워주어야 한다.
            if ( this.selected1[0]){
                console.log('가져오는 상품리스트의 프로젝트 인덱스',this.selected1[0].idx)
                this.productDatatableName = this.selected1[0].project_name
                this.getProductData(this.selected1[0].idx)
            } else {
                this.productDatatableName = ''
                this.dtatatabledata2 = []
                this.selected2 = ''
            }
        },
        logSearch: function()
        {
            let today = new Date();   
            if(this.logSearch != "")
            {
                let resultResult = this.dtatatabledata3.find(element=>element['user_id'].includes(this.logSearch));
                //search(this.logSearch);
                console.log("JS DATA COUNT " + resultResult.length + "     [" +  today+"]");
            }
            else{
                console.log("JS DATA COUNT  [" +  today+"]");
            }
            
        }
    },

};
</script>
